// extracted by mini-css-extract-plugin
export default {"relax":"Relax_relax__cXJIN","header":"Relax_header__BxOmc","wrapper":"Relax_wrapper__++DZZ","left":"Relax_left__82Q2I","right":"Relax_right__d8mWF"};